import { createApp } from "vue";
import store from "./stores";

import App from "./App.vue";
import router from "./router";
import "./styles/common.scss";
import "./styles/reset.scss";
import globalUtils from "@/utils/global";
import globalComponents from "@/components";
import "virtual:svg-icons-register";
import directives from "@/directives";
import { initSentry } from "@/utils/sentry";

// import { setupPermission } from "@/utils/permission";
const app = createApp(App);
initSentry({ app, router, releaseName: "cbo-adc-web" });
// 批量注册自定义指令
Object.keys(directives).forEach((directiveName) => {
  app.directive(directiveName, directives[directiveName]);
});

// 注册全局工具方法
app.use(globalUtils);
app.use(globalComponents);
app.use(store);
app.use(router);
// 路由守卫
// setupPermission();

app.mount("#app");
